import { ReviewCard } from '../../../components/wizard/ReviewCard';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';
import { useTranslation } from '../../../context/LanguageContext';

export function Step7Review() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">{t('wizard.reviewTitle')}</h2>
        <p className="text-sm text-slate-500 mt-1">{t('wizard.reviewSubtitle')}</p>
      </div>
      <ReviewCard />
      <NavigationButtons nextLabel={t('wizard.reviewNext')} />
    </div>
  );
}
